/**
 * @generated SignedSource<<bbe4b0190e194c4019d5083b136fb0ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Notifications_user$data = {
  readonly preferences: {
    readonly shareActivities: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ShareActivityAlert_user" | "ActivityFeed_user" | "NotificationsIcon_user">;
  readonly " $fragmentType": "Notifications_user";
};
export type Notifications_user$key = {
  readonly " $data"?: Notifications_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"Notifications_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Notifications_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shareActivities",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "Defer",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ShareActivityAlert_user"
            }
          ]
        },
        {
          "kind": "Defer",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ActivityFeed_user"
            }
          ]
        },
        {
          "kind": "Defer",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NotificationsIcon_user"
            }
          ]
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b6a51da8722acc22b81a7a70bd63ea2a";

export default node;
